import { createFileRoute } from "@tanstack/react-router"
import dayjs from "dayjs"
import { FormInputCardStack } from "../../../-components/__CLEANUP/_form-card"
import { DefaultButton, PrimaryButton } from "../../../-components/Buttons"
import { FormButtonGroup } from "../../../-components/form-button-group"
import { Page } from "../../../-components/Page"
import { useSuspenseQueryGet } from "../../../typed-client/hooks/use-suspense-query-get"
import { DepartmentSelect } from "../../../-components/department-select"
import { useTranslation } from "react-i18next"
import { YearPickerInput } from "@mantine/dates"
import { useUserLocalStorage } from "../-components/use-user-local-storage"
import { ReleasePeriodSelect } from "./-components/ReleasePeriodSelect"

export const Route = createFileRoute("/app/duties/print")({
  component: RouteComponent,
  beforeLoad: ({ context: { t } }) => ({ getTitle: () => t!("Print") }),
})

export function RouteComponent() {
  const [departmentId, setDepartmentId] = useUserLocalStorage<number | null>({
    key: "duty-roster-department",
    defaultValue: null,
  })

  const [year, setYear] = React.useState<Date>(new Date())
  const releasePeriods = useSuspenseQueryGet(
    "/api/Rapports/GetReleasePeriods",
    { departmentId: departmentId ?? 0, year: year.getFullYear() },
    {}
  )

  const [startDate, setStartDate] = React.useState<string | null>(
    releasePeriods.data.find((r) => r.weekOfYear === dayjs().week())
      ?.startDate ?? null
  )

  const createLink = ({ download }: { download: boolean }) =>
    // this link is probably wrong, or actually the component is wrong
    `/api/Rapports/GetDutyRosterPrint?&departmentId=${departmentId}&startdate=${startDate}&download=${download ? "true" : "false"}`

  const { t } = useTranslation("app_server")

  return (
    <Page>
      <FormInputCardStack>
        <DepartmentSelect
          label={t("Departments")}
          required
          onChange={(v) => {
            if (v) {
              setDepartmentId(v)
              setStartDate(null)
            }
          }}
          value={departmentId}
          getDefaultValue={(data) =>
            departmentId ? departmentId.toString() : data[0]?.value
          }
        />
        <YearPickerInput
          label={t("Year")}
          value={year}
          onChange={(v) => {
            if (v !== null) {
              setStartDate(null)
              setYear(new Date(v))
            }
          }}
        />
        {departmentId !== null ? (
          <ReleasePeriodSelect
            releasePeriods={releasePeriods.data}
            value={startDate}
            onChange={(v) => setStartDate(v)}
          />
        ) : null}
        <FormButtonGroup>
          <DefaultButton
            disabled={departmentId === null || startDate === null}
            onClick={() => {
              window.open(createLink({ download: true }), "_blank")
            }}
          >
            {t("Download")}
          </DefaultButton>
          <PrimaryButton
            disabled={departmentId === null || startDate === null}
            onClick={() => {
              window.open(createLink({ download: false }), "_blank")
            }}
          >
            {t("Show")}
          </PrimaryButton>
        </FormButtonGroup>
      </FormInputCardStack>
    </Page>
  )
}
